import React, { useEffect, useState } from "react";
import { Steps, Button, Divider, Row, Col, Icon, Input, message } from "antd";

// Styles
import { StepsAction, StepsContent } from "./styles";

import SelectionArticle from "./selectionArticle";
import ConfigProcess from "./configProcess";
import Recommendations from "./recommendations";
import EndProcess from "./endProcess";

import moment from "moment";
import useProcessDesings from "../../hooks/useProcessDesings";

//import multilanguage library
import { useTranslation } from "react-i18next";

const { Step } = Steps;

const DesingProcess = ({ changeTitle, edit, editArticle, editProcess, close }) => {
  const [current, setCurrent] = useState(edit ? 1 : 0);

  const [article, setArticle] = useState(editArticle || null);
  const [process, setProcess] = useState(editProcess || null);
  const [recommendation, setRecommendation] = useState({
    furnace_time: 0,
    quenching: 0,
    tempered_time: 0,
  });
  const [desingName, setDesingName] = useState((editProcess && editProcess.desingName) || "");

  const [modelQueringEnded, setModelQueringEnded] = useState(true);

  const { setDesignProcess, updateDesignProcess } = useProcessDesings();

  //To translate text
  const { t } = useTranslation();

  useEffect(() => {
    if (editProcess) {
      editProcess.furnace.enabled_ramp = editProcess.furnace.heating_ramp !== 5000;
      editProcess.tempered.enabled_ramp = editProcess.tempered.heating_ramp !== 5000;
    }
  }, []);

  useEffect(() => {
    changeTitle && changeTitle("new_design");
  }, [changeTitle]);

  const next = () => {
    setCurrent((prev) => prev + 1);
  };

  const prev = () => {
    setCurrent((prev) => prev - 1);
  };

  const handleChangeArticle = (art) => setArticle(art);
  const handleChangeProcess = (pro) => setProcess(pro);
  const handleChangeRecommendation = (rec) => {
    let key = Object.keys(rec)[0];
    setRecommendation((prevState) => ({ ...prevState, [key]: rec[key] }));
  };

  const modelQueringStatus = (status) => setModelQueringEnded(status);

  const isActive = () => {
    return desingName.length > 0 && modelQueringEnded;
  };

  const handleSave = async function (e) {
    e.preventDefault();
    let newProperties = [
      {
        id_variable: 77,
        value: process.furnace.temperature,
      },
      {
        id_variable: 78,
        value: process.furnace.enabled_ramp ? process.furnace.heating_ramp : 5000,
      },
      {
        id_variable: 79,
        value: process.furnace.piece_temperrature,
      },
      {
        id_variable: 87,
        value: recommendation.furnace_time,
      },
      {
        id_variable: 80,
        value: process.quenching.bath_type,
      },
      {
        id_variable: 81,
        value: process.quenching.bath_temperature,
      },
      {
        id_variable: 82,
        value: process.quenching.agitation_level,
      },
      {
        id_variable: 83,
        value: article.hard_coat,
      },
      {
        id_variable: 89,
        value: recommendation.quenching,
      },
      {
        id_variable: 90,
        value: process.tempered.temperature,
      },
      {
        id_variable: 85,
        value: process.tempered.enabled_ramp ? process.tempered.heating_ramp : 5000,
      },
      {
        id_variable: 88,
        value: recommendation.tempered_time,
      },
      {
        id_variable: 86,
        value: article.hardness_required,
      },
    ];

    if (!edit) {
      let newDes = {
        id_article: article.id_article,
        name: desingName,
        date: moment().format(),
        properties: newProperties,
      };

      const response = await setDesignProcess(newDes);
      if (response) {
        next();
      }

      //newData.id = new Date().getTime();
      //saveData(newData);
      //next();
    } else {
      let editDes = {
        id_design: process.id,
        id_article: article.id_article,
        name: desingName,
        properties: newProperties,
      };

      const response = await updateDesignProcess(editDes);
      if (response) {
        message.success(t("alerts.design_updated"));
        close();
      } else {
        message.error(t("alerts.design_not_updated"));
      }
    }

    //message.success("Diseño agregado");
    //setCurrent(0);
  };

  const finishDesing = () => {
    setCurrent(0);
    setArticle(null);
    setProcess(null);
    setDesingName("");
  };

  const steps = [
    {
      title: t("headers.design.article_selection"),
      content: <SelectionArticle handleChangeArticle={handleChangeArticle} article={article} />,
    },
    {
      title: t("headers.design.process_configuration"),
      content: <ConfigProcess article={article} handleChangeProcess={handleChangeProcess} process={process} />,
    },
    {
      title: t("headers.design.recommendations"),
      content: (
        <Recommendations
          article={article}
          process={process}
          recommendation={recommendation}
          handleChangeRecommendation={handleChangeRecommendation}
          modelQueringStatus={modelQueringStatus}
        />
      ),
    },
    {
      title: t("headers.design.end"),
      content: <EndProcess name={desingName} finishDesing={finishDesing} />,
    },
  ];
  return (
    <Row style={{ margin: 0 }} gutter={[16, 16]}>
      <Col span={24}>
        <Steps current={current}>
          {steps.map((item, i) =>
            edit && i === 3 ? null : <Step key={item.title} title={item.title} subTitle={i === 0 && article ? article.name : ""} />
          )}
        </Steps>

        <StepsAction>
          <Row gutter={[16, 16]} type="flex" justify={current === 0 ? "end" : "space-between"}>
            {current > 0 && current !== steps.length - 1 && (
              <Col>
                <Button disabled={edit && current === 1} onClick={prev}>
                  <Icon type="arrow-left" />
                  {t("button.prev")}
                </Button>
              </Col>
            )}
            {current < steps.length - 2 && (
              <Col>
                {edit && (
                  <Button onClick={() => close()}>
                    <Icon type="close" />
                    {t("button.cancel")}
                  </Button>
                )}
                {edit && <Divider type="vertical"></Divider>}
                <Button
                  style={{ marginLeft: 8 }}
                  type="primary"
                  onClick={next}
                  disabled={article && article.figure && article.figure.name === "cylinder" && article.grade === 1 ? false : true}
                >
                  {t("button.next")}
                  <Icon type="arrow-right" />
                </Button>
              </Col>
            )}
            {current === steps.length - 2 && (
              <Col>
                <Input
                  prefix={<Icon type="profile" style={{ color: "rgba(0,0,0,.25)" }} />}
                  value={desingName}
                  placeholder={t("placeholder.no_title")}
                  onChange={(el) => setDesingName(el.target.value)}
                  style={{ width: "200px" }}
                />
              </Col>
            )}
            {current === steps.length - 2 && (
              <Col>
                {edit && (
                  <Button onClick={() => close()}>
                    <Icon type="close" />
                    {t("button.cancel")}
                  </Button>
                )}
                {edit && <Divider type="vertical"></Divider>}
                <Button disabled={!isActive()} style={{ marginLeft: 8 }} type="primary" onClick={(e) => handleSave(e)}>
                  <Icon type="save" />
                  {edit ? t("button.update") : t("button.save")}
                </Button>
              </Col>
            )}
          </Row>
        </StepsAction>
        <StepsContent>{steps[current].content}</StepsContent>
      </Col>
    </Row>
  );
};
export default DesingProcess;
